import React, {useContext, useEffect, useState} from "react"
import AuthContext from "../../context/AuthContext";
import BookingsContainer from "../../components/BookingsContainer/BookingsContainer";
import useAdminService from "../../api/services/useAdminService";
import AdminNav from "../../components/AdminNav/AdminNav";
import Loading from "../../components/Loading/Loading";
//import './style.scss'


const UserAdminBookings = () => {
  const {user} = useContext(AuthContext)
  const [isLoading, setIsLoading] = useState(true)
  const [bookings, setBookings] = useState([])
  const {adminShowBookings} = useAdminService()
  const today = new Date()
  const nextYear = new Date()
  nextYear.setFullYear(today.getFullYear() + 1)
  const [dates, setDates] = useState([today, nextYear])
  
  useEffect(() => {
    adminShowBookings(
      (data) => {

        setBookings(data);
        setIsLoading(false)
      },
      (errors) => {
        setIsLoading(false)
      },
    )
  }, []);

  return (
    <div className="page-user-admin">
      {user && user.is_admin &&
        <>
          <AdminNav/>
          {isLoading
            ? <Loading/>
            :
            <div className="bookings-container">
              <BookingsContainer
                callbackConfirm={() => {
                }}
                showForAdmin={true}
                bookings={bookings}
                handleCalendarChange={() => {
                }}
                dates={dates}
                setDates={setDates}
                isLoading={isLoading}
              />
            </div>
          }
        </>
      }
    </div>
  )
}

export default UserAdminBookings